
import service from "../api/services/timetableService";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getTimetableList(context, reqData) {
      return service.getTimetableList(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
    addTimetable(context, formData) {
      return service.addTimetable(formData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
    editTimetable(context, reqData) {
      return service.editTimetable(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },

    deleteTimetable(context, reqData) {
      return service.deleteTimetable(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
  },
};
